export default [
  'video_filter_values',
  'video_tags',
  'teachers.image',
  'has_public_access',
  'related_videos',
  'is_user_favorite'
];
